import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NextPageService, NavigationLocation, PageLayout } from "@cvx/nextpage";
import { Component_MAWP } from "../../../services/component_mawp";
import { Subject } from "rxjs";
import { LTA_module } from "../../../services/lta_module";
import { LTAP_module } from "../../../services/ltap_module";
import { Form1 } from "../../../services/form1";
import { Level1Data } from "../../../services/level1Data";
import { Location } from "../../../services/locationInterface";
import { MatStepper } from "@angular/material/stepper";
import { WarningModalComponent } from "../../warning-modal/warning-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { FormControlsEventProxyService } from "../../../services/formcontrols_eventproxy_service";
import { MatRadioChange } from "@angular/material/radio";
import { VerticalvesselComponent } from "../../type-a-component/verticalvessel/verticalvessel.component";
import { HorizontalvesselComponent } from "../../type-a-component/horizontalvessel/horizontalvessel.component";
import { CarbonsteelandlowalloysteelComponent } from "../../type-a-component/carbonsteelandlowalloysteel/carbonsteelandlowalloysteel.component";
import { HighalloyandnonferroussteelComponent } from "../../type-a-component/highalloyandnonferroussteel/highalloyandnonferroussteel.component";
import { Overlay } from "@angular/cdk/overlay";
import { ComponentEventService } from "projects/fitnessforservice/src/services/component_event.service";
import { Component_MAEP } from "projects/fitnessforservice/src/services/component_maep";
import { MAEPComponent } from "../../maep/maep.component";
import { MAWPComponent } from "../../mawp/mawp.component";

@Component({
    selector: "local-metal-loss-profile-data",
    templateUrl: "local-metal-loss-profile-data.component.html",
    styleUrls: ["local-metal-loss-profile-data.component.css"],
    standalone: false
})
export class LocalMetalLossProfileDataComponent implements OnInit {
  localmetallossprofiledata_formGroup: FormGroup;
  @ViewChild("stepper") private myStepper: MatStepper;
  @ViewChild('mawpComponent') mawpComponent!: MAWPComponent;
  @ViewChild('maepComponent') maepComponent!: MAEPComponent;

  inspectionDataCalculate: Subject<boolean> = new Subject();
  disable_intnum_t_pt: Subject<boolean> = new Subject();
  public level1Data = Level1Data;

  applicability: string;
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  path: string;
  reevaluSub: any;
  //Shameer 
  typeA : number;
  isreevalu = true;
// ComponentTypeData : Data[];
  tooltipText1: string = '';
  tooltipText2: string = '';
  tooltipText3: string = '';
  tooltipText4: string = '';
  intUnittype:number;
  isExternalPressure = false;

  summary: string;
  result: string;
  inspectionDataResult: string;
  SelectedValue: string;
  isCheckboxDisabled = false;
  isCylAtmradio = true; // always disabled this radio button for the current requirement

  displayedColumns: string[] = ["selected", "x", "y"];
  dataSource: Location[];
  validationList = [];
  showDIRequiredMessage: boolean = false;
  componentType: string;

  lmlProfileData_intnum_t_pt: number;
  lmlProfileData_sngGrid_spacing: number;

  editTableText: string;

  firstFormGroup = this._formBuilder.group({
    applicabilityCheckbox: ["", Validators.requiredTrue],
    typeACheckbox:["",Validators.required],
    radio:["",],
  });
  secondFormGroup = this._formBuilder.group({});
  isLinear = true;
  isEditing = false;
  private isCsvImported = false;

  constructor(
    private NP: NextPageService,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private componentService: ComponentEventService,
    private formControlsEventProxyService: FormControlsEventProxyService    
  ) {
    this.path = activatedRoute.snapshot["_routerState"].url;

    this.LTAP_Assesment_Setup();
      this.localmetallossprofiledata_formGroup = this._formBuilder.group({
      radioButton_DI: ["", Validators.required]
    });
     //shameer   
     this.firstFormGroup.get('typeACheckbox').disable();
     this.firstFormGroup.get('applicabilityCheckbox').disable();
  }

  goToComponent() {

    if(((this.firstFormGroup.get('radio').value) != null) &&
    ((this.firstFormGroup.get('applicabilityCheckbox').enabled == true ) ||
    (this.firstFormGroup.get('typeACheckbox').enabled == true))
  )
{
    this.firstFormGroup.controls["applicabilityCheckbox"].markAsDirty({
      onlySelf: true,
    });
    this.firstFormGroup.controls["applicabilityCheckbox"].markAsTouched({
      onlySelf: true,
    });

    //shameer
    let typAcheckbox1 = this.firstFormGroup.controls["typeACheckbox"];
    typAcheckbox1.markAsDirty({
      onlySelf: true,
    });
    typAcheckbox1.markAsTouched({
      onlySelf: true,
    });

    this.goNextStep();
  } else{
    this.dialog.open(WarningModalComponent, {
      width: "450px",
      data: {
        warningMessage: [
          "Select an Option to Proceed!..Please.",
        ],
        caption: "FFS: Applicability and Limitations",
        captionCenter: true,
        cancelButtonShow: false,
      },
    });
  }
}

onNextClickcalculateSummary() {
    const selected = this.localmetallossprofiledata_formGroup.get('radioButton_DI')?.value;
    if (selected.toString().toUpperCase() === 'radioButton1_DI_enabled'.toString().toUpperCase()) {
      this.mawpComponent?.calculateSummary();
    } else if (selected.toString().toUpperCase() === 'radioButton2_DI_enabled'.toString().toUpperCase()) {
      this.maepComponent?.calculateSummary();
    } else {
      console.warn('Please select a pressure type.');
    }
  }

  getApplicabilityCheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("applicabilityCheckbox") as FormControl;
  }

  gettypeAcheckbox_formControl():FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }

  get isSphericalSelected(): boolean {
    return Number(this.firstFormGroup.get('radio')?.value) === 5;
  }

  /** Length unit label for the profile table headers: 'inch' (US Customary) or 'mm' (SI). */
  get lengthUnitLabel(): string {
    const unitType = parseInt(localStorage.getItem("unitType") || "0") || 0;
    return unitType === 1 ? "mm" : "inch";
  }

  ngOnInit(): void {
    this.summary = "";
    this.result = "";
    this.applicability = `  
      <ol>  
        <li>The original design criteria were in accordance with a recognized code or standard.</li>  
        <li>The component is not operating in the creep range. See the Help Menu for temperature limit used to define the creep range.</li>
        <li>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment.</li>  
        <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
        <li>Type A components subject to internal pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness.  Examples are: 
          <ol type="a">  
            <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
            <li>Spherical pressure vessels and storage spheres</li>  
            <li>Spherical, elliptical and torispherical formed heads</li>  
            <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li>  
            <li>Cylindrical atmospheric storage tank shell courses</li>  
          </ol>  
        </li>  
      </ol>  
    `;
    localStorage.setItem("calculationStep", "0"); //this is zero step (Applicability)

    this.formControlsEventProxyService
      .getLTAP_ApplicabilityEventSubject()
      .subscribe((v) => {
        this.updateApplicabilityCheckboxToChecked();
        this.firstFormGroup.get('applicabilityCheckbox').enable();
      });
       // shameer- start
     this.formControlsEventProxyService
     .getltaptypeAApplicabilitySubject()
     .subscribe((v) => {
       this.updatetypeACheckboxToChecked();
       this.firstFormGroup.get('typeACheckbox').enable();
       
     });
     this.formControlsEventProxyService
     .getltaptypeAupdateradioSubject()
     .subscribe((v) => {
       this.updateradiobuttonafterimport();
       this.updatedamageafterimport();
       this.updatetooltip();
     });
    // shameer -end
    this.reevaluSub = this.componentService.reevaluButtonEnabled.subscribe(
      enabled => this.isreevalu = !enabled
    );
    this.componentService.typeDamageSelected$.subscribe(val => {
      this.localmetallossprofiledata_formGroup.get('radioButton_DI').patchValue(val);
    });

    this.editTableText = "Edit table";
  }
  updateradiobuttonafterimport()
  {
    
    this.firstFormGroup.get('radio').patchValue(this.componentService.typearadioselectedValue.toString());
  
  }
   updatedamageafterimport() {
      // After importing and updating the service value
    this.localmetallossprofiledata_formGroup.get('radioButton_DI')
    .patchValue(this.componentService.typeDamageSelectedValue);
  }

   goToMAWPComponent() {
      const diVal = this.localmetallossprofiledata_formGroup.get('radioButton_DI')?.value;
      this.validationList = [];
      if (!diVal) {
        this.showDIRequiredMessage = true;
        this.localmetallossprofiledata_formGroup.get('radioButton_DI')?.markAsTouched();
        this.localmetallossprofiledata_formGroup.get('radioButton_DI')?.markAsDirty();
        return; // stay on Applied Load step
      }
      this.showDIRequiredMessage = false;
      const resultFromValidation: boolean = Component_MAWP.check_LocalMetalLoss_TypeOfData(
        this.localmetallossprofiledata_formGroup
      );
      this.validationList = Component_MAWP.validationMessageTypeOfData;
      if (!resultFromValidation) return;
      this.goNextStep();
  }

  goToMAEPComponent() {
      const diVal = this.localmetallossprofiledata_formGroup.get('radioButton_DI')?.value;
      this.validationList = [];
      if (!diVal) {
        this.showDIRequiredMessage = true;
        this.localmetallossprofiledata_formGroup.get('radioButton_DI')?.markAsTouched();
        this.localmetallossprofiledata_formGroup.get('radioButton_DI')?.markAsDirty();
        return; // stay on Applied Load step
      }
      this.showDIRequiredMessage = false;
      const resultFromValidation: boolean = Component_MAEP.check_LocalMetalLoss_TypeOfData(
        this.localmetallossprofiledata_formGroup
      );
      this.validationList = Component_MAEP.validationMessageTypeOfData;
      if (!resultFromValidation) return;
      this.goNextStep();
  }
  updatetooltip()
  {
   // this.tooltipText1 = this.componentService.typeatypeAinput1val.toString();

    const a1 = this.componentService.typeatypeAinput1val.toString();
    const a2 = this.componentService.typeatypeAinput2val.toString()

    const ut = this.componentService.typeAUnitTypeval.toString();
    const typaPF = this.componentService.typeAresultjsnval.toString();
    
    const Passres = "\n\nThe component meets the Type A screeing criteria";
    const Failres = "\n\nThe component doesn't meet the Type A screeing criteria.";    

    if(this.componentService.typearadioselectedValue.toString()== "1")
    {
      if (ut == "0")
      {
        const l1 = "Vertical Location of the Flaw, H (inch)";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
      
        if(typaPF == "0")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
        }else if(typaPF == "1")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
        }
        
      }
      else if( ut == "1")
      {
        const l1 = "Vertical Location of the Flaw, H*  (mm) *";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
       
        if(typaPF == "0")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
      }

      this.tooltipText2 ="";
      this.tooltipText3 ="";
      this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "2")
    {
      if (ut == "0")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *";
          const l2 = "\nDistance between saddle supports Lss  (inch) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
         
        }
        else if( ut == "1")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
          const l2 = "\nDistance between saddle supports Lss  (mm) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }

        this.tooltipText1 ="";
        this.tooltipText3 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "3")
    {
      if (ut == "0")
        {
          const l1 = "Maximum Operating Temperature, Top  (℉)";
          const l2 = "\nPipe Nominal size, NPS  (inch)";
         
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        else if( ut == "1")
        {
          const l1 = "Maximum Operating Temperature, Top  (℃)";
          const l2 = "\nPipe Nominal size, NPS  (mm)";
          
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        this.tooltipText1 ="";
        this.tooltipText2 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "4")
    {
        if (ut == "0")
          {
            const l1 = "Maximum Operating Temperature, Top  (℉)";
            const l2 = "\nPipe Nominal size, NPS  (inch)";
           
        if(typaPF == "0")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
          }
          else if( ut == "1")
          {
            const l1 = "Maximum Operating Temperature, Top  (℃)";
            const l2 = "\nPipe Nominal size, NPS  (mm)";
           
            if(typaPF == "0")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
              }else if(typaPF == "1")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
              }
          }
          this.tooltipText1 ="";
          this.tooltipText2 ="";
          this.tooltipText3 ="";
     }
      else if (this.componentService.typearadioselectedValue.toString()== "5")
      {
          if (ut == "0")
            {
              
            }
            else if( ut == "1")
            {
              
            }
            this.tooltipText1 ="";
            this.tooltipText2 ="";
            this.tooltipText3 ="";
            this.tooltipText4 ="";
      }
      
  }
  updateApplicabilityCheckboxToChecked() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    applicabilityCheckbox.setValue(true);
  }
//shameer
updateApplicabilityCheckboxToUnChecked() {
  let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
  applicabilityCheckbox.setValue(false);
}
  goNextStep() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    let typeACheckbox = this.gettypeAcheckbox_formControl();
    if ((applicabilityCheckbox.value === true)||(typeACheckbox.value === true))
      localStorage.setItem(
        "calculationStep",
        (this.myStepper.selectedIndex + 1).toString()
      );

    this.myStepper.next();
  }

  goPreviousStep() {
    localStorage.setItem(
      "calculationStep",
      (this.myStepper.selectedIndex - 1).toString()
    );
    this.myStepper.previous();
  }

  LTAP_Assesment_Setup() {
    Component_MAWP.MAWP_initialize();
    LTA_module.LTA_initialize();
    LTAP_module.LTAP_initialize();
    this.lmlProfileData_intnum_t_pt = LTAP_module.intnum_t_pt;
    this.lmlProfileData_sngGrid_spacing = LTAP_module.sngGrid_spacing;
    this.isCsvImported = false;

    Component_MAWP.strD_class = "LTAP";
    Component_MAWP.strD_iclass = 2;
    Component_MAWP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "LTAP";

    Component_MAEP.strD_class = "LTAP";
    Component_MAEP.strD_iclass = 2;
    Component_MAEP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "LTAP";
  }

  onYChange(element: Location, newValue) {
    element.y = Number(newValue);
  }

  onXChange(element: Location, newValue) {
    element.x = Number(newValue);
  }


  // Tolerance used when comparing floating-point grid-spacing values.
  private static readonly GRID_SPACING_TOLERANCE = 1e-6;

  /** True when the External Pressure (MAEP) option is selected. */
  private isExternalPressureSelected(): boolean {
    return (
      this.localmetallossprofiledata_formGroup.get("radioButton_DI")?.value ===
      "radioButton2_DI_enabled"
    );
  }

  /** Prefer the grid spacing stored on the module; fall back to the form value. */
  private resolveGridSpacing(): number {
    return LTAP_module.sngGrid_spacing == undefined || LTAP_module.sngGrid_spacing == null
      ? Number(this.lmlProfileData_sngGrid_spacing)
      : LTAP_module.sngGrid_spacing;
  }

  /**
   * The effective grid spacing represented by a set of rows.
   * External pressure = sum of all X values; Internal pressure = the step
   * increment (the first X value, since X = spacing, 2*spacing, ...).
   */
  private getTableGridSpacing(rows: Location[], isExternal: boolean): number {
    if (!rows || rows.length === 0) {
      return NaN;
    }
    if (isExternal) {
      return rows.reduce((sum, row) => {
        const xVal = Number(row.x);
        return sum + (isNaN(xVal) ? 0 : xVal);
      }, 0);
    }
    return Number(rows[1]?.x);
  }

  prepareThicknessProfileTable() {
    const intnum_t_pt = Number(this.lmlProfileData_intnum_t_pt);
    const sngGrid_spacing = this.resolveGridSpacing();
    const isExternal = this.isExternalPressureSelected();

    // 1. Reset the table when point count or grid spacing no longer match the inputs.
    this.resetTableIfInputsChanged(intnum_t_pt, sngGrid_spacing, isExternal);

    // 2. Keep a CSV-imported table if it still matches the current inputs.
    if (this.tryKeepCsvImportedTable(intnum_t_pt, sngGrid_spacing, isExternal)) {
      return;
    }

    // 3. Restore/keep data that came from a JSON import (module dataSource).
    if (this.tryRestoreFromModule()) {
      return;
    }

    // 4. Otherwise regenerate the table from the latest Inspection Data inputs.
    this.regenerateTable(intnum_t_pt, sngGrid_spacing, isExternal);
    this.inspectionDataCalculate.next(true);
  }

  /** Clears the table when the point count or grid spacing has changed. */
  private resetTableIfInputsChanged(
    intnum_t_pt: number,
    sngGrid_spacing: number,
    isExternal: boolean
  ): void {
    if (
      isNaN(intnum_t_pt) ||
      intnum_t_pt <= 0 ||
      !this.dataSource ||
      this.dataSource.length === 0
    ) {
      return;
    }

    const pointCountDiffers = this.dataSource.length !== intnum_t_pt;

    let gridSpacingDiffers = false;
    if (!isNaN(sngGrid_spacing) && sngGrid_spacing > 0) {
      const tableGridSpacing = this.getTableGridSpacing(this.dataSource, isExternal);
      if (!isNaN(tableGridSpacing)) {
        gridSpacingDiffers =
          Math.abs(sngGrid_spacing - tableGridSpacing) >
          LocalMetalLossProfileDataComponent.GRID_SPACING_TOLERANCE;
      }
    }

    if (pointCountDiffers || gridSpacingDiffers) {
      this.dataSource = [];
      LTAP_module.dataSource = [];
    }
  }

  /**
   * Keeps a CSV-imported table when it still matches the current inputs.
   * Returns true when the table was handled and no further work is needed.
   */
  private tryKeepCsvImportedTable(
    intnum_t_pt: number,
    sngGrid_spacing: number,
    isExternal: boolean
  ): boolean {
    if (!this.isCsvImported || !this.dataSource || this.dataSource.length === 0) {
      return false;
    }

    const tableGridSpacingValue = this.getTableGridSpacing(this.dataSource, isExternal);
    const pointCountMatches =
      !isNaN(intnum_t_pt) && intnum_t_pt === this.dataSource.length;
    const gridSpacingMatches =
      !isNaN(sngGrid_spacing) &&
      !isNaN(tableGridSpacingValue) &&
      Math.abs(sngGrid_spacing - tableGridSpacingValue) <=
        LocalMetalLossProfileDataComponent.GRID_SPACING_TOLERANCE;

    if (pointCountMatches && gridSpacingMatches) {
      LTAP_module.dataSource = [...this.dataSource];
      LTAP_module.intnum_t_pt = this.dataSource.length;
      this.inspectionDataCalculate.next(true);
      return true;
    }

    this.isCsvImported = false;
    return false;
  }

  /**
   * Restores the table from LTAP_module.dataSource (e.g. after a JSON import).
   * Returns true when the table was handled and no further work is needed.
   */
  private tryRestoreFromModule(): boolean {
    const moduleHasData = LTAP_module.dataSource && LTAP_module.dataSource.length > 0;
    if (!moduleHasData) {
      return false;
    }

    // Empty local table but module has data -> copy it back.
    if (!this.dataSource || this.dataSource.length === 0) {
      this.dataSource = [...LTAP_module.dataSource];
      this.inspectionDataCalculate.next(true);
      return true;
    }

    // Both have data -> keep current dataSource (prevents blanking after JSON import).
    this.inspectionDataCalculate.next(true);
    return true;
  }

  /** Regenerates the table rows from the current inputs, or clears it when inputs are invalid. */
  private regenerateTable(
    intnum_t_pt: number,
    sngGrid_spacing: number,
    isExternal: boolean
  ): void {
    if (!(sngGrid_spacing > 0 && intnum_t_pt > 0)) {
      this.dataSource = [];
      LTAP_module.dataSource = [];
      return;
    }

    LTAP_module.intnum_t_pt = intnum_t_pt;
    LTAP_module.sngGrid_spacing = sngGrid_spacing;

    const rows = isExternal
      ? this.buildExternalRows(intnum_t_pt, sngGrid_spacing)
      : this.buildInternalRows(intnum_t_pt, sngGrid_spacing);

    this.dataSource = [...rows];
    LTAP_module.dataSource = [...rows];
  }

  /** External pressure: each row gets an equal subdivision length (X = spacing / points). */
  private buildExternalRows(intnum_t_pt: number, sngGrid_spacing: number): Location[] {
    const subDivisionLength = intnum_t_pt > 0 ? sngGrid_spacing / intnum_t_pt : 0;
    return this.buildRows(intnum_t_pt, () => subDivisionLength);
  }

  /**
   * Internal pressure: X starts at the spacing value and increments by it.
   * e.g. spacing = 2, points = 10 -> 2, 4, 6, 8, 10, 12, 14, 16, 18, 20
   */
  private buildInternalRows(intnum_t_pt: number, sngGrid_spacing: number): Location[] {
    return this.buildRows(intnum_t_pt, (i) => sngGrid_spacing * (i));
  }

  /** Builds rows, preserving existing Y values by row index. */
  private buildRows(
    intnum_t_pt: number,
    xForIndex: (zeroBasedIndex: number) => number
  ): Location[] {
    const rows: Location[] = [];
    const existingData = this.dataSource || [];

    for (let i = 0; i < intnum_t_pt; i++) {
      const prevRow = existingData[i];
      const y = prevRow && !isNaN(Number(prevRow.y)) ? Number(prevRow.y) : 0;
      rows.push({ selected: false, x: xForIndex(i), y });
    }

    return rows;
  }

private openValidationErrorModal(message: string): void {
  this.dialog.open(WarningModalComponent, {
    width: "600px",
    data: {
      warningMessage: [message],
      caption: "Warning",
      captionCenter: true,
      cancelButtonShow: false,
    },
  });
}

  copySelectedRows() {
    let nodeData: Location[] = this.dataSource.filter(
      (item) => item.selected === true
    );
    let tbl: HTMLTableElement = document.createElement("table");
    let tblBody: HTMLTableSectionElement = document.createElement("tbody");
    nodeData.forEach((data) => {
      let row: HTMLTableRowElement = document.createElement("tr");
      row.innerHTML = `<td>${data.x}</td><td>${data.y}</td>`;
      tblBody.appendChild(row);
    });
    tbl.appendChild(tblBody);
    document.body.appendChild(tbl);
    navigator.clipboard.writeText(tbl.innerText);
    tbl.style.display = "none";
  }

  chooseFile(): void {
    document.getElementById("csvFileInput")?.click();
    const fileInput = document.getElementById(
      "csvFileInput"
    ) as HTMLInputElement;
    fileInput.value = "";
  }

  editTable(element: any) {
    if (!this.isEditing) {
      this.isEditing = true;
      this.editTableText = "Save table";
    } else {
      this.isEditing = false;
      this.editTableText = "Edit table";

      if (this.dataSource && this.dataSource.length > 0) {
        const isExternalPressure =
          this.localmetallossprofiledata_formGroup.get("radioButton_DI")?.value ===
          "radioButton2_DI_enabled";
        let xSum = 0;
        this.dataSource.forEach((row) => {
          const xVal = Number(row.x);
          if (!isNaN(xVal)) {
            xSum += xVal;
          }
        });
        // Internal pressure: spacing is the step increment (first X value).
        const firstX = Number(this.dataSource[1]?.x);
        const gridSpacing = isExternalPressure
          ? xSum
          : (isNaN(firstX) ? 0 : firstX);
        LTAP_module.sngGrid_spacing = gridSpacing;
        this.lmlProfileData_sngGrid_spacing = gridSpacing;
      } else {
        LTAP_module.sngGrid_spacing = 0;
        this.lmlProfileData_sngGrid_spacing = 0;
      }
    }
  }

  selectAll(event: any) {
    const checked = event.checked;
    this.dataSource.forEach((element) => {
      element.selected = checked;
    });
  }

  selectRow(event: any, element: any) {
    element.selected = event.checked;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    this.parseCSVFile(file);
  }

  parseCSVFile(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      const csvData = reader.result as string;
      this.importDataFromCSV(csvData);
    };
    reader.readAsText(file);
  }

  importDataFromCSV(csvData: string): void {
    LTAP_module.intnum_t_pt = 0;
    LTAP_module.sngGrid_spacing = 0;

    const tempMap: Location[] = [];

    const selected = false;
    const lines = csvData.split("\n");
    let xSum = 0;
    let firstX = NaN;
    for (const line of lines) {
      if (line.trim() === "") {
        continue; // Skip empty lines, avoid filling the map with 'NaN' values
      }
      const [xStr, yStr] = line.split(",");
      const x = parseFloat(xStr);
      const y = parseFloat(yStr);
      xSum += x;
      if (isNaN(firstX)) { firstX = x; } // First X = step increment for internal
      tempMap.push({ selected, x, y });
      ++LTAP_module.intnum_t_pt;
    }
    
    // Determine grid spacing based on pressure type
    const isExternalPressure =
      this.localmetallossprofiledata_formGroup.get("radioButton_DI")?.value ===
      "radioButton2_DI_enabled";
    
    // For external pressure: sum of all X values
    // For internal pressure: the step increment (first X value)
    LTAP_module.sngGrid_spacing = isExternalPressure ? xSum : firstX;
    
    this.lmlProfileData_intnum_t_pt = LTAP_module.intnum_t_pt;
    this.lmlProfileData_sngGrid_spacing = LTAP_module.sngGrid_spacing;
    this.disable_intnum_t_pt.next(true);

    this.dataSource = tempMap;
    LTAP_module.dataSource = tempMap;
    this.isCsvImported = true;
  }

  handleSummaryData(data: any) {
    this.summary = data;
  }

  validateThicknessProfileDataTable() {
    LTAP_module.grid_yes = 0;
    LTAP_module.grid_ok = 0;
    for (let i = 0; i < this.dataSource.length; i++) {
      if (this.dataSource[i].x < 0 || this.dataSource[i].y <= 0) {
        LTAP_module.grid_ok = -1;
      }
    }
  }

 validateLengthOfUnstiffenedTable(): boolean {
  if (LTAP_module.sngGrid_spacing !== 0) {
    const L_1 = LTAP_module.sngAxialEdgeofMLL1;
    const L2 = LTAP_module.sngAxialEdgeofMLL2;
    const Grid_sp = LTAP_module.sngGrid_spacing;
     const total = L_1 + Grid_sp + L2
      const tolerance = 0.000001;
     if (Math.abs(total - Component_MAEP.sngL) >= tolerance)
     {
      const msg =
        "Metal loss length in the axial direction plus the axial distances L_1 and L_2, must be equal to unstiffened / unsupported length, L";
      this.openValidationErrorModal(msg);
      return false;
    }
  }

  return true;
}

  goToPreviousStepFromThicknessData() {
    this.validateThicknessProfileDataTable();
    this.myStepper.previous();
  }
  
  // Validate that no X value exceeds current measured thickness trd
  private validateXNotGreaterThanTrd(): boolean {
    if (!this.dataSource || this.dataSource.length === 0) {
      return true;
    }
    const trd = this.isExternalPressure ? Component_MAEP.sngtrd : Component_MAWP.sngtrd; 
    if (trd === undefined || trd === null || isNaN(Number(trd))) {
      return true;
    }
    const maxX = Number(trd);
    for (let i = 0; i < this.dataSource.length; i++) {
      const yVal = Number(this.dataSource[i].y);
      if (!isNaN(yVal) && yVal > maxX) {
        const msg =
          "No thickness reading should be greater than the current measured thickness away from the metal loss.";
        this.openValidationErrorModal(msg);
        return false;
      }
    }

    return true;
  }
  
  // Validate that the sum of all X values matches the S value
  private validateSumOfXEqualsGridSpacing(): boolean {
    if (!this.isExternalPressure) {
      return true;
    }
    if (!this.dataSource || this.dataSource.length === 0) {
      return true;
    }
    // Use this.lmlProfileData_sngGrid_spacing if available, otherwise fall back to LTAP_module.sngGrid_spacing
    let gridSpacing = Number(this.lmlProfileData_sngGrid_spacing);
    if ((!gridSpacing || gridSpacing < 0) && LTAP_module && LTAP_module.sngGrid_spacing) {
      gridSpacing = Number(LTAP_module.sngGrid_spacing);
    }
    const sumX = this.dataSource.reduce((sum, row) => {
      const xVal = Number(row.x);
      return sum + (isNaN(xVal) ? 0 : xVal);
    }, 0);

    // If gridSpacing is not positive but sumX is, use sumX for validation (import fallback)
    if (gridSpacing <= 0 && sumX > 0) {
      gridSpacing = sumX;
    }
    // Relaxed tolerance to 1e-3 to avoid floating-point issues
    if (Math.abs(sumX - gridSpacing) > 1e-3) {
      this.openValidationErrorModal(
        "The sum of all Sub-division Length data table must equal the value entered for Metal loss length in the axial direction."
      );
      return false;
    }
    return true;
  }

    calculateResult(): void {
    this.isExternalPressure =
    this.localmetallossprofiledata_formGroup.get("radioButton_DI")?.value ===
    "radioButton2_DI_enabled";
    
    if(!this.isExternalPressure)
    {
    this.validateThicknessProfileDataTable();
    }
    else if(this.isExternalPressure)
    {
      if (!this.validateLengthOfUnstiffenedTable()) {
      return;
      }
    }

    if (!this.validateXNotGreaterThanTrd()) {
      return;
    }

    if (!this.validateSumOfXEqualsGridSpacing()) {
      return;
    }
  
    if(!this.isExternalPressure){
      if (LTAP_module.grid_ok === -1) {
        this.openWrongInputErrorModal();
        return;
      }
  }

    LTAP_module.LTA2_RSF(Component_MAWP.intEquip, this.dataSource);
    this.isExternalPressure =
      this.localmetallossprofiledata_formGroup.get("radioButton_DI")?.value ===
      "radioButton2_DI_enabled";

    this.result = LTA_module.LTA_calc(this.isExternalPressure);
    this.myStepper.next();
  }

  private openWrongInputErrorModal(): void {
    this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: {
        warningMessage: [
          "Check your input! Either missing data, zeros, or negative values !",
        ],
        caption: "Error",
        captionCenter: true,
        cancelButtonShow: false,
      },
    });
  }
  onRadioChange(event:MatRadioChange)
  {
    console.log('Selected value',event.value);
    if(event.value ==1)
    {
      const dialogRef = this.dialog.open(VerticalvesselComponent,{height : '725px' ,width :'1200px', disableClose :true})
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Data from dialog:', result.data1,result.data2); 
        if (result.cancel) {

          this.updateTypeAradioToUncheck();
          this.updateApplicabilityCheckboxToUnChecked();
          this.updatetypeACheckboxToUnChecked();
          this.firstFormGroup.get('applicabilityCheckbox').disable();
          this.firstFormGroup.get('typeACheckbox').disable();

           //clear all tool tips
           this.tooltipText1="";
           this.tooltipText2="";
           this.tooltipText3="";
           this.tooltipText4=""; 

        } else {
          console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
          if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
            {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').disable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').enable();

                 //for typea result in report generation
                 localStorage.setItem("TypeAPassorFail","0");

                  //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;
                
               this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }
            
            }
            else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
              {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').enable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').disable();

                 //for typea result in report generation
                 localStorage.setItem("TypeAPassorFail","1");

                  //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }


                 
              }
        }
     
      }
    }); 
    this.componentService.updateTypeASelectedValue(1); // as we selected vertical 
    localStorage.setItem("TypeAradioselection","1");  
    }
    else if(event.value==2)
    {
      const dialogRef = this.dialog.open(HorizontalvesselComponent,{height : '650px' ,width :'1200px',disableClose :true})
     
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

               //clear all tool tips
               this.tooltipText1="";
               this.tooltipText2="";
               this.tooltipText3="";
               this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                   //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";
               


                 //for tooltip on vessels
                 const userinputs = localStorage.getItem('horizontalinputs');
                 const Input_data = userinputs ? JSON.parse(userinputs) : null;
                 const a1 = Input_data.inputvalue1;
                 const a2 = Input_data.inputvalue2;

                 this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;

              }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                    //for enabling Reeval button
                this.isreevalu = false;
                //for removing vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('horizontalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
 
               }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(2); // as we selected Horizontal
      localStorage.setItem("TypeAradioselection","2"); 
    }
    else if(event.value==3)
    {
      const dialogRef = this.dialog.open(CarbonsteelandlowalloysteelComponent,{height : '520px' ,width :'1200px',disableClose :true})
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

            
            //clear all tool tips
            this.tooltipText1="";
            this.tooltipText2="";
            this.tooltipText3="";
            this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                    //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('carbonsteelinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
 
               }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                    //for enabling Reeval button
                    this.isreevalu = false;

                    //for removing tool tips of vertical/horizontal /highalloy  tooltip
                    this.tooltipText1="";
                    this.tooltipText2="";
                    this.tooltipText4="";
    
    
                    //for tooltip on vessels
                    const userinputs = localStorage.getItem('carbonsteelinputs');
                    const Input_data = userinputs ? JSON.parse(userinputs) : null;
                    const a1 = Input_data.inputvalue1;
                    const a2 = Input_data.inputvalue2;

                    this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                   if(this.intUnittype==0) //us customary
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                    const res = "\n\nThe component meets the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
                  }
                  else if(this.intUnittype == 1) //si units
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                    const res = "\n\nThe component meets the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
    
                  }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(3); // as we selected carbon and low alloy
      localStorage.setItem("TypeAradioselection","3"); 
    }
    else if(event.value==4)
    {
       const dialogRef = this.dialog.open(HighalloyandnonferroussteelComponent,{height : '520px' ,width :'1200px', disableClose :true})
       dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

             //clear all tool tips
             this.tooltipText1="";
             this.tooltipText2="";
             this.tooltipText3="";
             this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();
                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");

                   //for enabling Reeval button
                   this.isreevalu = false;

                   //for removing tool tips of vertical/horizontal /carbon tooltip
                   this.tooltipText1="";
                   this.tooltipText2="";
                   this.tooltipText3="";
   
   
                   //for tooltip on vessels
                   const userinputs = localStorage.getItem('highalloyinputs');
                   const Input_data = userinputs ? JSON.parse(userinputs) : null;
                   const a1 = Input_data.inputvalue1;
                   const a2 = Input_data.inputvalue2;
  
                   this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;
  
                   if(this.intUnittype==0) //us customary
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                    const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                    this.tooltipText4 = lbl1+a1+lbl2+a2+res;
                  }
                  else if(this.intUnittype == 1) //si units
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                    const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                    this.tooltipText4 = lbl1+a1+lbl2+a2+res;
    
                  }
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                      //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /carbon tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText3="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('highalloyinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
 
               }
                  //for typea result in report generation
                  localStorage.setItem("TypeAPassorFail","1");

                }
                
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(4);// as we selected HighAlloy
      localStorage.setItem("TypeAradioselection","4"); 

    }
    else
    {   
      if(event.value==5)  // when 2nd radio button is selected , consider typeA as passed
      {

         //for enabling Reeval button
         this.isreevalu = false;

         //clear all tool tips
         this.tooltipText1="";
         this.tooltipText2="";
         this.tooltipText3="";
         this.tooltipText4="";
 
         //for typea result in report generation
         localStorage.setItem("TypeAPassorFail","1");

        // Spherical components support only Internal Pressure.
        this.onChangeRadioButton1_DI('radioButton1_DI_enabled');
      }
      
      // when we select 5 or 6 or 7 radio buttons
       this.updateApplicabilityCheckboxToUnChecked();
       this.firstFormGroup.get('applicabilityCheckbox').enable();
       this.updatetypeACheckboxToUnChecked();
       this.firstFormGroup.get('typeACheckbox').disable();
       this.componentService.updateTypeASelectedValue(5); // as we selected Spherical components

       localStorage.setItem("TypeAradioselection","5"); 
    }
   
  }
  updateTypeAradioToUncheck()
  {
    this.firstFormGroup.get('radio').patchValue(null);    
  }

  gettypeAradio_formControl(): FormControl {
    return this.firstFormGroup.get("radio") as FormControl;
  }

  updatetypeACheckboxToChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(true);
  }

  updatetypeACheckboxToUnChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(false);
  }
  gettypeACheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }
  typeareevaluate()
  {
    this.updateTypeAradioToUncheck();
    this.updateApplicabilityCheckboxToUnChecked();
    this.updatetypeACheckboxToUnChecked();
    this.firstFormGroup.get('applicabilityCheckbox').disable();
    this.firstFormGroup.get('typeACheckbox').disable();
    
    //for disbling Reeval button
    this.isreevalu = true;
    this.tooltipText1="";
    this.tooltipText2="";
    this.tooltipText3="";
    this.tooltipText4="";
    localStorage.removeItem('verticalinputs');
  }

   onChangeRadioButton1_DI(value: string) {
      const previousValue = this.componentService.radioButtonDI;

        // Save the value in your form if needed
        this.localmetallossprofiledata_formGroup.get('radioButton_DI').setValue(value);

      // When switching Internal/External, force component-type dropdowns back to Select Type.
      if (previousValue && previousValue !== value) {
        Component_MAWP.intEquip = -1;
        Component_MAEP.intEquip = -1;
        this.componentService.updateCompMAWPintEquip(-1);
        this.componentService.updateCompMAEPintEquip(-1);
      }

        this.showDIRequiredMessage = false;
    
        // Set LML_module.intLoadingType based on selection
        if (value.toString().toUpperCase() === 'RADIOBUTTON1_DI_ENABLED') {
            LTA_module.intLoadingType = 0; // Internal Pressure
            // Store radio button value in both components
             Component_MAWP.strRadio = 0;
             Component_MAEP.strRadio = 0;
            Component_MAWP.strD_class = "LTAP";
            Component_MAWP.strD_iclass = 2;
            Component_MAWP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
            Form1.prev_strD_class = "LTAP";
        } else if (value.toString().toUpperCase() === 'RADIOBUTTON2_DI_ENABLED') {
            LTA_module.intLoadingType = 1; // External Pressure
            // // Store radio button value in both components
            Component_MAWP.strRadio = 1;
            Component_MAEP.strRadio = 1;
            Component_MAEP.strD_class = "LTAP";
            Component_MAEP.strD_iclass = 2;
            Component_MAEP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
            Form1.prev_strD_class = "LTAP";
        }
        // Store in service instead of localStorage
         this.componentService.radioButtonDI = value;
      }
}
